// Print helper: opens a print window with certificate SVG + optional Audio
// QR block (headphones label + Family Passcode line) in Full-Color or
// Ink-Saver (grayscale) mode. The browser print dialog handles Save-as-PDF.
// QR stays black-on-white in both modes so it always scans cleanly.
export function printCertificate({ svgMarkup, qrMarkup = "", label = "", passcode = "", inkSaver = false, title = "Certificate" }) {
  const w = window.open("", "_blank", "width=920,height=760");
  if (!w) return false;
  w.document.write(`<!doctype html><html><head><title>${title}</title>
  <meta name="robots" content="noindex, nofollow" />
  <style>
    body { font-family: 'Baloo 2', 'Comic Sans MS', sans-serif; margin: 24px; text-align: center; ${inkSaver ? "filter: grayscale(1) contrast(1.05);" : ""} }
    .cert { max-width: 620px; margin: 0 auto; }
    .cert svg { width: 100%; height: auto; }
    .qr { margin-top: 16px; display: inline-flex; flex-direction: column; align-items: center; gap: 6px; }
    .qr svg { background: #ffffff; padding: 10px; border: 2px solid #000; border-radius: 10px; }
    .qr p { margin: 0; font-weight: 800; font-size: 15px; color: #000; }
    .qr .pass { font-size: 17px; letter-spacing: 3px; }
    @media print { body { margin: 0; } }
  </style></head><body>
  <div class="cert">${svgMarkup}</div>
  ${qrMarkup ? `<div class="qr">${qrMarkup}<p>${label}</p>${passcode ? `<p class="pass">Passcode: ${passcode}</p>` : ""}</div>` : ""}
  <script>window.onload = function () { setTimeout(function () { window.print(); }, 350); };</script>
  </body></html>`);
  w.document.close();
  return true;
}
